var _jsxFileName = "/codebuild/output/src1571341075/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/consents/ConsentsScreen.tsx";
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { IconClose, InformationalScreen, ListCard, ListItem } from '@adc/parallax-component-library';
import { MainContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const mapStateToProps = ({
  auth,
  env: {
    phoneLanguage
  },
  nav: {
    query
  }
}) => {
  return {
    patient: auth.include.patient,
    phoneLanguage,
    displayLibreAssistConsent: !query.libreAssistConsent ? true : query.libreAssistConsent === 'true'
  };
};
const connector = connect(mapStateToProps);
const ConsentsScreen = ({
  patient,
  phoneLanguage,
  displayLibreAssistConsent
}) => {
  var _patient$consents$ass2;
  const consentsItems = useMemo(() => {
    var _patient$consents$ass;
    const items = [];
    items.push({
      text: 'Consents.microcopy.consentsOptions.healthcareCommunications',
      onPress: () => mediator.publish('router:navigate', '/hipaa')
    });
    items.push({
      text: 'Consents.microcopy.consentsOptions.researchConsent',
      onPress: () => mediator.publish('router:navigate', '/rwe')
    });
    if ((_patient$consents$ass = patient.consents.assist) !== null && _patient$consents$ass !== void 0 && _patient$consents$ass.at && phoneLanguage === 'en-US' && displayLibreAssistConsent) {
      items.push({
        text: 'Consents.microcopy.consentsOptions.libreAssistDataUse',
        onPress: () => mediator.publish('router:navigate', '/assist')
      });
    }
    return items;
  }, [(_patient$consents$ass2 = patient.consents.assist) === null || _patient$consents$ass2 === void 0 ? void 0 : _patient$consents$ass2.at, phoneLanguage, displayLibreAssistConsent]);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('Consents.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(IconClose, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 65,
            columnNumber: 22
          }
        }),
        label: 'Consents.title-Pressable',
        onPress: () => mediator.publish('router:back')
      },
      testID: 'Consents.title'
    },
    testID: "Consents",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ListCard, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 13
    }
  }, consentsItems.map((item, index) => /*#__PURE__*/React.createElement(ListItem, {
    key: index.toString(),
    title: i18n.t(item.text),
    testID: item.text,
    onPress: item.onPress,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 17
    }
  })))))));
};
export default connector(ConsentsScreen);